WiseMetering.Views.IntegrationLicenseTabs = WiseMetering.Views.Content.extend({
    icon: 'wiseStore',

    initialize({ model, view }) {
        this.name = this.model.partner().get('name');

        const views = this.viewsBySlug(model.get('partner_slug'));

        if (!views.integrations && views.configurations && view === 'integrations') {
            view = 'configurations';
        }

        this.tabs = [];

        if (views.integrations) {
            this.tabs.push({
                active: view === 'integrations',
                href: `/integration_licenses/${model.id}/integrations`,
                id: 'integrations',
                name: i18next.t('glossary.integrations'),
                view: views.integrations
            });
        }

        if (views.configurations) {
            this.tabs.push({
                active: view === 'configurations',
                href: `/integration_licenses/${model.id}/configurations`,
                id: 'configurations',
                name: i18next.t('glossary.configurations'),
                view: views.configurations
            });
        }

        // Partners we harvest FROM write run logs; wise_api is inbound-only, so it has no
        // run to log and reports through the API request counters instead.
        if (WiseMetering.currentUser.get('superuser') && !views.apiRequests) {
            this.tabs.push({
                active: view === 'logs',
                href: `/integration_licenses/${model.id}/logs`,
                id: 'logs',
                name: i18next.t('glossary.logs'),
                view: WiseMetering.Views.IntegrationLogs
            });
        }

        if (views.apiRequests && WiseMetering.currentUser.get('superuser')) {
            this.tabs.push({
                active: view === 'api_requests',
                href: `/integration_licenses/${model.id}/api_requests`,
                id: 'api_requests',
                name: i18next.t('glossary.api_requests'),
                view: views.apiRequests
            });
        }

        this.tabs.push({
            active: view === 'licenses',
            href: `/integration_licenses/${model.id}/licenses`,
            id: 'licenses',
            name: i18next.t('glossary.licenses'),
            view: WiseMetering.Views.IntegrationLicensesTab
        });

        if (views.rawData && WiseMetering.currentUser.get('superuser')) {
            this.tabs.push({
                active: view === 'raw_data',
                href: `/integration_licenses/${model.id}/raw_data`,
                id: 'raw_data',
                name: i18next.t('glossary.raw_data'),
                view: views.rawData
            });
        }
    },

    viewsBySlug: function(slug) {
        switch (slug) {
            case 'contazara':
                return {
                    configurations: WiseMetering.Views.ContazaraConfigurationsTable,
                    integrations: WiseMetering.Views.ContazaraIntegrationsTable
                };
            case 'data_portal':
                return {
                    configurations: WiseMetering.Views.DataPortalConfigurationsTable,
                    integrations: WiseMetering.Views.DataPortalIntegrationsTable
                };
            case 'datelka':
                return {
                    configurations: WiseMetering.Views.DatelkaConfigurationsTable,
                    integrations: WiseMetering.Views.DatelkaIntegrationsTable
                };
            case 'degree_days':
                return {
                    integrations: WiseMetering.Views.DegreeDayIntegrationsTable
                };
            case 'desigo':
                return {
                    configurations: WiseMetering.Views.DesigoConfigurationsTable,
                    integrations: WiseMetering.Views.DesigoIntegrationsTable
                };
            case 'e_redes':
                return {
                    integrations: WiseMetering.Views.ERedesIntegrationsTable
                };
            case 'electricity_maps':
                return {
                    integrations: WiseMetering.Views.ElectricityMapsIntegrationsTable,
                    rawData: WiseMetering.Views.IntegrationRawData
                };
            case 'infraspeak':
                return {
                    configurations: WiseMetering.Views.InfraspeakConfigurationsTable,
                    integrations: WiseMetering.Views.InfraspeakIntegrationsTable
                };
            case 'measurabl':
                return {
                    configurations: WiseMetering.Views.MeasurablConfigurationsTable,
                    integrations: WiseMetering.Views.MeasurablIntegrationsTable
                };
            case 'navigator':
                return {
                    configurations: WiseMetering.Views.NavigatorConfigurationsTable,
                    integrations: WiseMetering.Views.NavigatorIntegrationsTable
                };
            case 'netmore':
                return {
                    integrations: WiseMetering.Views.NetmoreIntegrationsTable
                };
            case 'nextbitt_maintenance':
                return {
                    configurations: WiseMetering.Views.NextbittMaintenanceConfigurationsTable,
                    integrations: WiseMetering.Views.NextbittMaintenanceIntegrationsTable
                };
            case 'nextbitt_data':
                return {
                    configurations: WiseMetering.Views.NextbittDataConfigurationsTable,
                    integrations: WiseMetering.Views.NextbittDataIntegrationsTable
                };
            case 'shopper_trak':
                return {
                    configurations: WiseMetering.Views.ShopperTrakConfigurationsTable,
                    integrations: WiseMetering.Views.ShopperTrakIntegrationsTable
                };
            case 'sphera':
                return {
                    configurations: WiseMetering.Views.SpheraConfigurationsTable,
                    integrations: WiseMetering.Views.SpheraIntegrationsTable
                };
            case 'v2_charge':
                return {
                    configurations: WiseMetering.Views.V2CConfigurationsTable,
                    integrations: WiseMetering.Views.V2CIntegrationsTable
                };
            case 'waterbeep':
                return {
                    integrations: WiseMetering.Views.WaterbeepIntegrationsTable
                };
            case 'weather_api':
                return {
                    integrations: WiseMetering.Views.WeatherAPIIntegrationsTable
                };
            case 'wise_api':
                return {
                    apiRequests: WiseMetering.Views.WiseApiRequestsTable,
                    configurations: WiseMetering.Views.WiseApiConfigurationsTable,
                    integrations: WiseMetering.Views.WiseApiIntegrationsTable
                };
            case 'wise_json':
                return {
                    configurations: WiseMetering.Views.WiseJsonConfigurationsTable,
                    integrations: WiseMetering.Views.WiseJsonIntegrationsTable
                };
            case 'zaptec':
                return {
                    configurations: WiseMetering.Views.ZaptecConfigurationsTable,
                    integrations: WiseMetering.Views.ZaptecIntegrationsTable
                };
            default:
                return {};
        }
    }
});
